const map = {
	"./cdp_white_logo.png": 88754,
	"./logo_cdp_big.png": 29571,
	"./user-profile-grey_256x256.png": 97153,
	"images/png/cdp_white_logo.png": 88754,
	"images/png/logo_cdp_big.png": 29571,
	"images/png/user-profile-grey_256x256.png": 97153
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29570;